import { matchPath } from "react-router-dom";

/**
 * The articles the Help Center suggests for the page the user is on. The first
 * entry whose `path` matches wins, so specific paths go before general ones.
 * Paths are react-router patterns (`:id`, a trailing `/*` for the page and
 * everything under it) for the routes in src/app/Routes.js and
 * src/app/pages/workspace/routes.js. Articles the user's roles can't see are
 * left out.
 */
export const PAGE_HELP = [
   // Surveys
   {
      path: "/survey/edit/:id",
      articles: ["build-survey", "survey-logic", "translate-survey", "publish-and-share"]
   },
   { path: "/survey/edit-survey-details/:id", articles: ["build-survey", "publish-and-share"] },
   { path: "/survey/import", articles: ["import-survey", "build-survey"] },
   {
      path: "/survey/create-survey/*",
      articles: ["create-survey", "survey-templates", "import-survey"]
   },
   { path: "/survey/data/:id", articles: ["survey-analytics"] },
   { path: "/survey/submission/:id", articles: ["survey-analytics"] },
   { path: "/survey/highlights/:id", articles: ["survey-analytics"] },
   { path: "/survey-analytics/*", articles: ["survey-analytics", "project-dashboard"] },
   {
      path: "/surveys",
      articles: ["create-survey", "publish-and-share", "survey-templates", "archive-delete-restore"]
   },

   // Workspaces and projects
   {
      path: "/admin-workspaces",
      articles: ["getting-around", "manage-workspaces", "create-project"]
   },
   { path: "/workspace", articles: ["getting-around", "manage-workspaces", "create-project"] },
   { path: "/workspace/new-work-space", articles: ["manage-workspaces"] },
   { path: "/workspace/add", articles: ["manage-workspaces"] },
   { path: "/workspace/edit/:id", articles: ["manage-workspaces"] },
   { path: "/space-selection", articles: ["getting-around", "create-project"] },
   { path: "/project-selection/create-project/*", articles: ["create-project"] },
   { path: "/project-selection", articles: ["getting-around", "create-project"] },
   { path: "/projects", articles: ["create-project", "project-dashboard"] },
   { path: "/dashboard/edit-project", articles: ["create-project"] },
   { path: "/dashboard", articles: ["project-dashboard", "assign-data-collection"] },
   { path: "/deleted-items", articles: ["archive-delete-restore", "manage-workspaces"] },
   { path: "/admin-deleted-items", articles: ["archive-delete-restore", "manage-workspaces"] },

   // Collecting responses
   { path: "/task-management/*", articles: ["assign-data-collection", "project-team"] },
   { path: "/assignments/*", articles: ["assign-data-collection", "project-team"] },
   { path: "/mytasks", articles: ["my-tasks", "collect-offline"] },
   { path: "/tasks", articles: ["my-tasks", "collect-offline"] },
   { path: "/audience/*", articles: ["audiences", "send-campaign"] },
   { path: "/automated-campaigns/*", articles: ["send-campaign", "audiences"] },

   // Team
   { path: "/team", articles: ["project-team", "roles-and-permissions"] },
   {
      path: "/admin-user-management/*",
      articles: ["organization-members", "roles-and-permissions"]
   },

   // Account and billing
   { path: "/profile", articles: ["profile-information", "delete-or-deactivate-account"] },
   { path: "/login-information", articles: ["login-and-security"] },
   { path: "/organizations", articles: ["switch-organization"] },
   {
      path: "/subscription-plans",
      articles: ["manage-subscription", "enterprise-plan", "usage-statistics"]
   },
   { path: "/balance", articles: ["add-funds", "send-campaign"] },
   { path: "/usage", articles: ["usage-statistics", "manage-subscription"] },
   { path: "/tickets/*", articles: ["support-tickets"] }
];

/** The suggested articles for `pathname`, out of the ones the user can see. */
export const getPageArticles = (pathname, articles, pages = PAGE_HELP) => {
   const page = pages.find(({ path }) => matchPath(path, pathname));
   if (!page) return [];
   return page.articles.map((id) => articles.find((article) => article.id === id)).filter(Boolean);
};
